import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { Slider } from "primereact/slider";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import "./AgentConfig.scss";

export default function AgentConfig({
  config,
  setIsAgentConfig,
  setConfig,
}: {
  config: any;
  setIsAgentConfig: any;
  setConfig: any;
}) {
  const [localConfig, setLocalConfig] = useState(config);
  const handleFormChange = (value: any, field: string) => {
    const data = { ...localConfig };
    data[field] = value;
    setLocalConfig(data);
  };

  const handleSaveConfig = () => {
    setConfig(localConfig);
    setIsAgentConfig(false);
  };

  return (
    <Dialog
      header="Config"
      visible={true}
      draggable={false}
      style={{ width: "400px" }}
      onHide={() => {
        setIsAgentConfig(false);
      }}
    >
      <div className="settings-form">
        <div className="form-group">
          <label>Max Iteration</label>
          <InputNumber
            value={localConfig.maxIteration}
            onValueChange={(e) => handleFormChange(e.value, "maxIteration")}
          />
        </div>
        <div className="form-group">
          <label>Score Threshold</label>
          <Slider
            value={localConfig.threshold}
            onChange={(e) => handleFormChange(e.value, "threshold")}
            style={{ width: "14rem" }}
          />
          <InputNumber
            value={localConfig.threshold}
            onValueChange={(e) => handleFormChange(e.value, "threshold")}
          />
        </div>
        <div className="states">
          <label>Human Eval After State</label>
          <div className="form-group">
            <div className="form-group">
              <Checkbox
                inputId="analysis"
                checked={localConfig.analysis}
                onChange={(e) => handleFormChange(e.target.checked, "analysis")}
              />
              <label htmlFor="analysis">Analysis</label>
            </div>
            <div className="form-group">
              <Checkbox
                inputId="codeGen"
                checked={localConfig.codeGen}
                onChange={(e) => handleFormChange(e.target.checked, "codeGen")}
              />
              <label htmlFor="codeGen">Code Gen</label>
            </div>
            <div className="form-group">
              <Checkbox
                inputId="review"
                checked={localConfig.review}
                onChange={(e) => handleFormChange(e.target.checked, "review")}
              />
              <label htmlFor="review">Review</label>
            </div>
          </div>
        </div>
        <div className="actions">
          <Button
            label="Close"
            severity="secondary"
            onClick={() => setIsAgentConfig(false)}
            outlined
          />
          <Button label="Save" onClick={() => handleSaveConfig()} />
        </div>
      </div>
    </Dialog>
  );
}
